import { getApp, getApps, initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAF93XCyVZn0uM-4qODmExOqD__m927zVQ",
  authDomain: "restaurantapp-5264e.firebaseapp.com",
  databaseURL: "https://restaurantapp-5264e-default-rtdb.firebaseio.com",
  projectId: "restaurantapp-5264e",
  storageBucket: "restaurantapp-5264e.appspot.com",
  messagingSenderId: "65987527596",
  appId: "1:65987527596:web:6e52722bb0422b65803009",
};

// Initialize Firebase
const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
const firestore = getFirestore(app);
const storage = getStorage(app);

export { app, firestore, storage };
